import AdvisorsBanner from "../../components/AdvisorsBanner";
import AdvisorsSection from "../../components/AdvisorsSection";
import Steps from "../../components/Steps";
import Review from "../../components/Review";
import Banner from "../../components/Banner";

const AsesoresPage = () => {
  return (
    <div>
      <AdvisorsBanner />
      <AdvisorsSection />
      <Steps />
      <Review />
      <Banner />
    </div>
  );
};

export default AsesoresPage;
